export interface AppStorage {
  get<T = unknown>(key: string): T | null
  set<T>(key: string, value: T): void
  remove(key: string): void
  clear(): void
}

function createStorage(driver: Storage): AppStorage {
  return {
    get<T = unknown>(key: string): T | null {
      try {
        const raw = driver.getItem(key)
        if (raw === null) return null
        return JSON.parse(raw) as T
      } catch {
        return null
      }
    },
    set<T>(key: string, value: T): void {
      try {
        driver.setItem(key, JSON.stringify(value))
      } catch {
        return
      }
    },
    remove(key: string): void {
      driver.removeItem(key)
    },
    clear(): void {
      driver.clear()
    },
  }
}

export const storage = {
  local: createStorage(localStorage),
  session: createStorage(sessionStorage),
}

export const StorageKeys = {
  USER_LANG: 'user_lang',
} as const
